import { render, staticRenderFns } from "./dangerJournalResult.vue?vue&type=template&id=f44b0d6a"
import script from "./dangerJournalResult.vue?vue&type=script&lang=js"
export * from "./dangerJournalResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f44b0d6a')) {
      api.createRecord('f44b0d6a', component.options)
    } else {
      api.reload('f44b0d6a', component.options)
    }
    module.hot.accept("./dangerJournalResult.vue?vue&type=template&id=f44b0d6a", function () {
      api.rerender('f44b0d6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/danger/dangerJournalResult.vue"
export default component.exports